export default __webpack_public_path__ + "static/featureSectionImg-20d15ba04741f698c4de2ccf00451d48.png";